<template>
    <main-dialog
        :show="value"
        :title="$t('login')"
        maxWidth="400px"
        @close="$emit('input', false)"
    >
        <form @submit="login">
            <b-form-group>
                <b-input type="password" v-model="password" :placeholder="$t('password')" />
            </b-form-group>

            <b-button variant="primary" type="submit" block>{{ $t('confirm') }}</b-button>
        </form>
    </main-dialog>
</template>

<script>
export default {
    props: {
        value: {
            type: Boolean
        },

        project_uuid: {
            type: String,
            default: null
        }
    },

    data: function() {
        return {
            password: null
        }
    },

    methods: {
        login(e) {
            e.preventDefault()

            const popup = this.$loadingPopup()

            this.$http.post("/v1/user/login", {
                username: this.$store.getters.getClaims.Entity.identificator, 
                password: this.password},
            {
                headers: {
                    'X-Project-Uuid': this.project_uuid
                }
            }).then(r => {
                this.$emit('success')
                this.$emit('input', false)
            }).catch(err => {
                this.$bvToast.toast(err.response.data.message, {
                    title: this.$t('error'),
                    variant: 'danger'
                })
            }).finally(() => {
                popup.hide()
            })
        }
    }
}
</script>